// Shared client identity. Reads/writes the SAME localStorage key the old
// account.js used ("rearcade.account"), so the un-bundled runtime modules
// (highscores.js) and the game bridges see one consistent signed-in identity.
// The full auth context/UI builds on this in the auth task.
export interface Account {
  token: string;
  username: string;
  email?: string;
  expiresAt?: number;
}

export const ACCOUNT_KEY = "rearcade.account";

export function getAccount(): Account | null {
  try {
    const raw = localStorage.getItem(ACCOUNT_KEY);
    if (!raw) return null;
    const acct = JSON.parse(raw) as Account;
    if (acct?.expiresAt && acct.expiresAt < Date.now()) {
      localStorage.removeItem(ACCOUNT_KEY);
      return null;
    }
    return acct?.username ? acct : null;
  } catch {
    return null;
  }
}

export function isSignedIn(): boolean {
  return getAccount() !== null;
}
